import { of as observableOf, Observable } from 'rxjs';

import { map, mergeMap } from 'rxjs/operators';
import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
// import { Navigation } from './navigation';
import { UserRoleService } from './user-role.service';

import { StorageRefService } from './storage-ref.service';
import { NavigationLink } from './navigation-store.service';
import { WindowRefService } from './window-ref.service';

const NAV_URL_API = '/caas/navigation';
const NAV_URL_LOCAL = '/json/navigation.json';

export interface NavigationSvc {
  getNav(
    appName: string,
    access: string,
    domain: string,
    userRoles$
  ): Observable<NavigationLink[]>;
  OpenSurveyWindow(feedbackSSOId: string): void;
}

@Injectable()
export class NavigationService implements NavigationSvc {
  roles: string;
  status = false;
  isProspect = false;
  statusObservable: Observable<any>;

  constructor(
    private http: Http,
    private userRoleService: UserRoleService,
    private storageService: StorageRefService,
    public window: WindowRefService
  ) {}

  getNav(
    appName: string,
    access: string,
    domain: string,
    userRoles$: Observable<string>
  ): Observable<NavigationLink[]> {
    if (!userRoles$) {
      userRoles$ = this.userRoleService.getRoles(access, domain).pipe(
        map(response => {
          if (response && response.r) {
            return response.r;
          } else {
            return response;
          }
        })
      );
    }

    return userRoles$.pipe(
      mergeMap(userRoles => {
        this.roles = userRoles.replace(/\^/gi, ',').toLowerCase();
        let rolesArray = this.roles.split(',');
        const isCustomer = rolesArray.find(
          custRole => custRole === 'indv_customer'
        );
        if (isCustomer === 'indv_customer') {
          rolesArray = rolesArray.filter(e => e !== 'indv');
          this.roles = rolesArray.join();
        }

        const hasIndvRole = rolesArray.find(indvRole => indvRole === 'indv');
        if (hasIndvRole === 'indv') {
          this.isProspect = true;
        }

        const NAV_URL = /localhost/.test(domain) ? NAV_URL_LOCAL : NAV_URL_API;
        const finalUrl =
          domain +
          NAV_URL +
          (NAV_URL.includes('?') ? '&' : '?') +
          `app=${appName}&role=${this.roles}` +
          '&' +
          Date.now();
        let navJson = this.storageService.getItem(
          `${appName}` + `${this.roles}Nav`
        );
        if (navJson === null || navJson === undefined) {
          return this.http.get(finalUrl).pipe(
            map((res: Response) => {
              navJson = res.json();
              this.storageService.setItem(
                `${appName}` + `${this.roles}Nav`,
                JSON.stringify(navJson)
              );

              return navJson;
            })
          );
        } else {
          return observableOf(JSON.parse(navJson));
        }
      })
    );
  }

  OpenSurveyWindow(feedbackSSOId: string): void {
    let surveyUrl =
      'https://www.surveymonkey.com/r/RHCZQVJ?id=' + feedbackSSOId;
    const left = screen.width / 2 - 200;
    const top = screen.height / 2 - 250;
    const custOU = this.window.nativeWindow['custOU']
      ? this.window.nativeWindow['custOU']
      : '';
    if (custOU) {
      surveyUrl += '&bu=' + custOU;
    }
    this.window.nativeWindow.open(
      surveyUrl,
      '',
      'top=' +
        top +
        ',left=' +
        left +
        'toolbar=no, scrollbars=yes, resizable=yes, width=800, height=600'
    );
  }
}
